import {
  StyleAccordionItemTitleWrapper,
  StyleAccordionItemWrapper,
  StyleAccordionIconWrapper,
} from './style'
import Skeleton from '../skeleton'
const AccordionLoader = () => {
  return (
    <StyleAccordionItemWrapper>
      <StyleAccordionItemTitleWrapper>
        <Skeleton width={`30%`} height={10} radius={4} />
        <StyleAccordionIconWrapper>
          <Skeleton width={40} height={40} radius={20} />
        </StyleAccordionIconWrapper>
      </StyleAccordionItemTitleWrapper>
    </StyleAccordionItemWrapper>
  )
}

export default AccordionLoader
